import { OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { MatSnackBar } from '@angular/material';
import { WidgetErrorTypeEnum } from '../../models/widget-error-type.enum';
import { defaultContentErrorConfig } from '../../data/content-error-config';
import { authErrorConfig, defaultAuthErrorConfig } from '../../data/auth-error-config';
import { webGLErrorConfig, defaultWebGLErrorConfig } from '../../data/webgl-error-config';
import { get } from 'lodash';
// generic error messaging
var defaultErrorConfig = {
    title: "We're unable to find the page you're looking for.",
    description: "Please check your URL or return to our <a href=\"/\">homepage</a>."
};
var WidgetErrorComponent = /** @class */ (function () {
    function WidgetErrorComponent(route, snackBar) {
        this.route = route;
        this.snackBar = snackBar;
        this.errorTypeEnum = WidgetErrorTypeEnum;
        this.supportURL = 'https://support.biodigital.com';
        this.errorType = WidgetErrorTypeEnum.Content;
    }
    Object.defineProperty(WidgetErrorComponent.prototype, "widgetError", {
        get: function () {
            var config;
            // get custom error config based on error type + error code (i.e., specific auth issues)
            switch (this.errorType) {
                case WidgetErrorTypeEnum.Auth:
                    config = authErrorConfig[this.errorCode] || defaultAuthErrorConfig;
                    break;
                case WidgetErrorTypeEnum.Engine:
                    config = webGLErrorConfig[this.errorCode] || defaultWebGLErrorConfig;
                    break;
                case WidgetErrorTypeEnum.Content:
                    config = defaultContentErrorConfig;
                    break;
                default:
                    config = defaultErrorConfig;
                    break;
            }
            return config;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(WidgetErrorComponent.prototype, "title", {
        get: function () {
            return get(this.widgetError, 'title', defaultErrorConfig.title);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(WidgetErrorComponent.prototype, "description", {
        get: function () {
            return get(this.widgetError, 'description', defaultErrorConfig.description);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(WidgetErrorComponent.prototype, "url", {
        get: function () {
            return get(this.widgetError, 'url', defaultErrorConfig.url);
        },
        enumerable: true,
        configurable: true
    });
    WidgetErrorComponent.prototype.ngOnInit = function () {
        this.initErrorHandling();
    };
    WidgetErrorComponent.prototype.initErrorHandling = function () {
        var _a = this.route.snapshot.queryParams, errorType = _a.errorType, errorCode = _a.errorCode;
        this.errorType = errorType;
        this.errorCode = errorCode;
    };
    WidgetErrorComponent.prototype.handleActionClick = function (url) {
        // launch URL in new window
        var targetWindow = window.open(url);
        if (!targetWindow) { // notify user if blocked      
            this.snackBar.open('Unable to open link in new window, please check your pop-up settings.');
        }
    };
    return WidgetErrorComponent;
}());
export { WidgetErrorComponent };
